export const SWALWITHBOOTSTRAPBUTTONSPARAMS = {
    customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
    },
    buttonsStyling: false,
    message: {
        title: 'En êtes vous sûr ?',
        html: `htmlMessage.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#569C5B',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Oui',
    },
};
